import { Control } from 'react-hook-form';

import { ILoanListGroupFilterResponse } from '@patient-fi/fed-types';

import { FilterItem } from '../index';

interface GroupFilterItemProps {
  filter: ILoanListGroupFilterResponse;
  control?: Control;
}

function GroupFilterItem({ filter, control }: GroupFilterItemProps) {
  return (
    <>
      {filter.filters.map((filter) => (
        <FilterItem control={control} key={filter.filterScheme.filterQueryName} filter={filter.filterScheme} />
      ))}
    </>
  );
}

export default GroupFilterItem;
